import template from './prepay-type.jade';
import validation from './../../../services/validation';
import prepayTypeOptions from '../../../enums/prepay-type';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

const config = {
  default: {
    required: true,
  },
  garage: {
    required: false,
  },
};

export default angular.module('cian.addForm.prepayType', []).directive('cianAfPriceAndDealTermsPrepayType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'categoryService',
    'deviceService',
    'store',
    function (categoryService, deviceService, store) {
      this.isMobile = deviceService.isMobile;
      this.items = prepayTypeOptions;

      this.validation = validation(this.form, 'bargainTerms.prepayType', {
        required: 'Укажите предоплату',
      });

      this.handleChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'prepayment');
      };

      const { objectType } = categoryService.getInfoByCategory(this.ad.category);
      this.config = config[objectType] || config.default;
    },
  ],
  controllerAs: 'prepayType',
  template,
})).name;
